const DOJO_EXERCISE_ANSWER_STATUS = {
    SOLVED: 'solved',
    UNSOLVED: 'unsolved',
}

export default DOJO_EXERCISE_ANSWER_STATUS
